import { Links, Paths } from "../../constants";
import { NetworkGraphNodeType } from "../../models";
import { UserDto } from "./UserDto";

interface NodeDto {
  id: string;
  label: string;
  type: number;
  depth: number;
}

interface PeopleNodeDto extends NodeDto {
  profilePhotoSmallUrl: string | null;
  profilePhotoLargeUrl: string | null;
  email: string;
  roles: {
    parent:
      | {
          name: string;
          slug: string;
        }
      | undefined;
    guid: string;
    name: string;
    isPrimaryRole: boolean;
    engagementPercentage: number;
  }[];
}

interface TeamNodeDto extends NodeDto {
  slug: string;
  parent:
    | {
        name: string;
        slug: string;
      }
    | undefined;
  description: string;
  members: UserDto[];
}

const getNodeUrl = (node: NodeDto) => {
  switch (node.type) {
    case NetworkGraphNodeType.RootTeam:
    case NetworkGraphNodeType.ParentTeam:
    case NetworkGraphNodeType.ChildTeam:
      const teamNode = node as TeamNodeDto;
      return Links.Team(teamNode.slug);
    case NetworkGraphNodeType.Member:
      return Links.User(node.id);
    case NetworkGraphNodeType.Role:
      return Links.Role(node.id);
    default:
      return Paths.NotFound;
  }
};

const getNodeImage = (imageUrl: string | null) => {
  let image: HTMLImageElement | null = null;

  if (imageUrl != null) {
    image = new Image();
    image.src = imageUrl;
  }

  return image;
};

export { getNodeImage, getNodeUrl };
export type { NodeDto, PeopleNodeDto, TeamNodeDto };
